import { ApolloQueryResult } from '@apollo/client';

import { TotalVouchersCountQuery, VoucherFilter, useTotalVouchersCountQuery } from '@ocx/graphql';

export type UseTotalVouchersCountParams = {
  filter?: VoucherFilter;
  skip?: boolean;
};

export type UseTotalVouchersCountReturn = {
  totalVouchersCount: number;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<TotalVouchersCountQuery>>;
};

export const useTotalVouchersCount = ({
  filter,
  skip,
}: UseTotalVouchersCountParams = {}): UseTotalVouchersCountReturn => {
  const { data, loading, refetch } = useTotalVouchersCountQuery({
    skip,
    fetchPolicy: 'cache-and-network',
    variables: { filter: filter ?? null },
  });

  const totalVouchersCount = data?.customer?.membership?.vouchers?.totalCount ?? 0;

  return { totalVouchersCount, loading, refetch };
};
